/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const menuSearchForm = () => {
  const clear = document.querySelector('.js-search-clear');
  const input = document.querySelector('.js-search-input');

  const clearFormInput = () => {
    input.value = '';
    input.focus();
  };

  clear.addEventListener('click', () => {
    clearFormInput();
  });
};

export default menuSearchForm;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/eco-chisel/src/scripts/modules/menuSearchForm.js